import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import App from './components/App';
import Disclaimer from './pages/Disclaimer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import ComingSoon from './pages/ComingSoon';
import About from './pages/About';
import Tokenomics from './pages/Tokenomics';
import Updates from './pages/Updates';
import { MaintenanceWrapper } from './components/MaintenanceWrapper';
import { maintenanceConfig } from './config/maintenance';
import './styles/main.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <MaintenanceWrapper>
        <App />
      </MaintenanceWrapper>
    ),
  },
  {
    path: '/about',
    element: (
      <MaintenanceWrapper>
        <About />
      </MaintenanceWrapper>
    ),
  },
  {
    path: '/tokenomics',
    element: (
      <MaintenanceWrapper>
        <Tokenomics />
      </MaintenanceWrapper>
    ),
  },
  {
    path: '/updates',
    element: (
      <MaintenanceWrapper>
        <Updates />
      </MaintenanceWrapper>
    ),
  },
  {
    path: '/disclaimer',
    element: (
      <MaintenanceWrapper>
        <Disclaimer />
      </MaintenanceWrapper>
    ),
  },
  {
    path: '/privacy-policy',
    element: (
      <MaintenanceWrapper>
        <PrivacyPolicy />
      </MaintenanceWrapper>
    ),
  },
  {
    path: '/terms-of-use',
    element: (
      <MaintenanceWrapper>
        <TermsOfUse />
      </MaintenanceWrapper>
    ),
  },
  {
    path: '/coming-soon',
    element: maintenanceConfig.isMaintenanceMode ? <ComingSoon /> : <Navigate to="/" replace />,
  },
]);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
); 